export default "__VITE_ASSET__CJy9uXM___"